import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { DeletePalletDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-pallet-dialog.component';
import { HistoryLogsComponent } from 'src/app/core/dialogs/history-logs/history-logs.component';
import { BtnCellRendererDeleteClipboard } from 'src/app/core/grid/btn-cell-render-delete'
import { LogsService } from 'src/app/service/document-control/logs.service';
import { ExportStateService } from 'src/app/service/export-state.service';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss'],
  standalone: false
})
export class LogsComponent implements OnInit {
  gridApi: any;
  columnDefs = [];
  displayRowData = [];
  context: any;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  defaultColDef;
  isAccessible = false;
  successMessage
  errorMessage
  gridOptions
  icons;
  paginationPageSize: number = 20;
  setPagination = 'true';
  @ViewChild('agGrid', { static: true }) agGrid
  dynamicHeight: number;
  totalRecords = 0; // Replace with your actual total records count
  sRecord = 1;
  eRecord = 1;
  cPage = 1;
  tPage = 0;
  rpPage: any = 20;
  endRecord = 0;
  pgDropDown = [
    { value: 5, selected: false },
    { value: 10, selected: false },
    { value: 20, selected: true },
    { value: 50, selected: false },
    { value: 'ALL', selected: false },
  ]

  constructor(public dialog: MatDialog, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly exportStateService: ExportStateService,
    private readonly constants: Constants, private readonly router: Router, private readonly logsService: LogsService) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true,

    }
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 55;
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.columnDefs = [
      {
        headerName: "ID", field: "queueId", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, minWidth: 90, maxWidth: 90
      },
      {
        headerName: "PROCESS", field: "type", sortable: true, unSortIcon: true, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true
      },
      {
        headerName: "CREATED", field: "createdTime", sortable: true, unSortIcon: true, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, comparator: this.dateComparator
      },
      {
        headerName: "COMPLETED", field: "completedTime", sortable: true, unSortIcon: true, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, comparator: this.dateComparator
      },
      {
        headerName: "COMPLETED BY", field: "completedByUser", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true
      },
      {
        headerName: "ACTIONS", field: "history_deleteclipboard", minWidth: 100, maxWidth: 100, cellRenderer: BtnCellRendererDeleteClipboard
      }];
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };

    this.refreshData();
    // this.checkRoles();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }
  async checkRoles() {
    await this.exportStateService.getRoles();
    const roles = this.exportStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_NAMCPlanner60EXP)) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // }  // Commented for APM
  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);

    if (date1Number == null && date2Number == null) { // NOSONAR
      return 0;
    }
    if (date1Number == null) { // NOSONAR
      return -1;
    }
    if (date2Number == null) {// NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }

  openRouteLevel(route) {
    this.router.navigate([`${route}`]);
  }

  sizeToFit() { this.gridApi.sizeColumnsToFit(); }

  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

  goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

  goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
    { this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length)); this.updatePaginationDetails(); }
    else { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails(); }
  }

  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
  }

  getCurrentPage(): boolean {
    if (this.cPage == 1) {  // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }

  isLastPage(): boolean {
    this.currentPageForTotalPage = Number(this.cPage);
    if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  rppChanged(event: any) {
    this.cPage = 1;
    event.target.value === 'ALL' ? this.gridApi?.setGridOption('paginationPageSize', this.totalRecords) : this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
    this.updatePaginationDetails();
  }

  updatePaginationDetails() {
    if (this.gridApi) {
      this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
      this.tPage = this.gridApi.paginationGetTotalPages();

      this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
      this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
      this.totalRecords = this.gridApi.paginationGetRowCount();
      this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
    }
  }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  deleteTemplateRow(data, pagename) {
    let displayRowIndex;
    if (pagename == 'history_deleteclipboard') { // NOSONAR

      const dialogRef = this.dialog.open(
        DeletePalletDialogComponent, {
        disableClose: true,
        width: 'max-content',
        data: {
          header: 'Are you sure you want to delete this History Log?',
          description: `Queue ID:  ${data.queueId} ,  Type: ${data.type}`,
        }
      });
      dialogRef.afterClosed().subscribe(result => {

        if (result.event == 'ConfirmEvent') { // NOSONAR
          this.ngxUiLoaderService.start(this.constants.LoaderComponent)
          this.logsService.deleteHistory(data.queueId).subscribe(
            response => {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              if (response == "Success") { // NOSONAR
                this.successMessage = this.constants.APIDataDeleted;
                setTimeout(() => {
                  this.successMessage = "";
                  this.errorMessage = "";
                }, this.constants.notificationMessageTimeShort);
                displayRowIndex = this.displayRowData.findIndex(x => x.queueId == data.queueId) // NOSONAR
                this.displayRowData.splice(displayRowIndex, 1);
                this.gridApi?.setGridOption('rowData', this.displayRowData);
                this.rowCount = this.displayRowData.length;
                if (this.displayRowData.length) {
                  this.totalRecords = this.displayRowData.length;
                  this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
                  this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
                  this.sRecord = 1
                  this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
                  if (this.cPage > this.tPage) {
                    this.cPage = 1;
                  }
                }
              }
            }, _error => {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.errorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
            }
          );
        }
        this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
      });


    }
  }

  onBtExport() {

  }

  clipboardTemplateRow(data, pagename) {
    if (pagename == 'history_deleteclipboard') { // NOSONAR

      const dialogRef = this.dialog.open(
        HistoryLogsComponent, {
        disableClose: true,
        width: '800px',
        height: '374px',
        data: {
          eventType: 'VIEWLOGS',
          queueId: data.queueId
        }
      });
      dialogRef.afterClosed().subscribe(result => {

        if (result.event == 'CloseEvent') { // NOSONAR
          // do something 
        }
      });

    }
  }

  refreshData() {
    this.displayRowData = []
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.logsService.loadDataHistory().subscribe(
      response => {

        this.displayRowData = response
        this.gridApi?.setGridOption('rowData', this.displayRowData);
        this.rowCount = this.displayRowData.length;
        if (this.displayRowData.length) {
          this.totalRecords = this.displayRowData.length;
          this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
          this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
          this.sRecord = 1
          this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
          if (this.cPage > this.tPage) {
            this.cPage = 1;
          }
        }

        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      },
      _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
      }
    );
  }
}

function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 16) { // NOSONAR
    return null;
  }
  const minNumber = Number.parseInt(date?.substring(14, 16));
  const hourNumber = Number.parseInt(date?.substring(11, 13));

  const yearNumber = Number.parseInt(date?.substring(6, 10));
  const dayNumber = Number.parseInt(date?.substring(3, 5));
  const monthNumber = Number.parseInt(date?.substring(0, 2));

  return yearNumber * 100000000 + monthNumber * 1000000 + dayNumber * 10000 + hourNumber * 100 + minNumber;
}